export const ADD_MESSAGE_MUTATION = 'addMessageMutation';
export const REMOVE_MESSAGE_MUTATION = 'removeMessageMutation';
export const CLEAR_MESSAGES_MUTATION = 'clearMessagesMutation';
export const TOGGLE_LOADING_MUTATION = 'toggleLoadingMutation';
export const TOGGLE_MODAL_MUTATION = 'toggleModalMutation';
